import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
// import { DatePicker } from "@progress/kendo-react-dateinputs";
import '@progress/kendo-theme-default/dist/all.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSelector } from 'react-redux';
import { Pagination } from 'antd';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import MembersTable from './Common/MembersTable';
import SelectList from './Common/SelectList';
import AlertMessage from './Common/AlertMessage';
import SearchBtn from './Common/SearchBtn';
import ConvertButtons from './Common/ConvertButtons';

const AllMembers = ({ isShow, setIsShow }) => {
    const memberTable = [
        {
            id: 1,
            name: 'Shila',
            phone: '9843265743',
            pkg: 'Basic(Gym & Cardio)',
            duration: '5 months',
            Sdate: '2077-11-12',
            EDate: '2078-11-12',
            status: 'New',
            address: 'narayangarh'
        },
        {
            id: 2,
            name: 'Shilaaaa',
            phone: '9843265743',
            pkg: 'Basic(Gym & Cardio)',
            duration: 'per day',
            Sdate: '2077-11-12',
            EDate: '2077-11-12',
            status: '',
            address: 'Bharatpur',
        },
        {
            id: 3,
            name: 'Geeta',
            phone: '9878665712',
            status: 'Renew',
            duration: '3 Months',
            pkg: 'Zumba(with Gym & Cardio)',
            Sdate: '2077-08-12',
            EDate: '2078-05-12',
            address: 'kamalpur'
        },
        {
            id: 4,
            name: 'Shah',
            phone: '9843223143',
            pkg: 'Zumba(with Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: '5 Months',
            status: 'New',
            address: 'chitwan'
        },
        {
            id: 5,
            name: 'Reman',
            phone: '9875823987',
            pkg: 'Basic(Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: '1 Year',
            status: 'Renew',
            address: 'Ramnagar'
        },
        {
            id: 6,
            name: 'Harman',
            phone: '9875823987',
            pkg: 'Zumba',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Week',
            status: '',
            address: 'Harinagar'
        },
        {
            id: 7,
            name: 'Rakesh',
            phone: '9875823987',
            pkg: 'Zumba(with Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: '1 Months',
            status: 'Renew',
            address: 'Gitanagar'
        },
        {
            id: 8,
            name: 'Suraj',
            phone: '9875823987',
            pkg: 'Zumba',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Months',
            status: '',
            address: 'Furfurinagar'
        },
        {
            id: 9,
            name: 'Smantha',
            phone: '9875823987',
            pkg: 'Zumba',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Months',
            status: '',
            address: 'Canada'
        },
        {
            id: 10,
            name: 'Samop',
            phone: '9875823987',
            pkg: 'Basic(Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Day',
            status: '',
            address: 'India'
        },
        {
            id: 11,
            name: 'Hezal',
            phone: '9875823987',
            pkg: 'Basic(Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Months',
            status: '',
            address: 'France'
        },
        {
            id: 12,
            name: 'Maria',
            phone: '9875823987',
            pkg: 'Basic(Gym & Cardio)',
            Sdate: '2076-09-12',
            EDate: '2078-11-12',
            duration: 'Per Months',
            status: '',
            address: 'China'
        },

    ];
    const [data, setData] = useState(memberTable);
    const [values, setValues] = useState({ memberType: 'All' });
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const dataRef = React.createRef();
    const { alert } = useSelector(state => state.alert);

    const filteredData = useMemo(() => {
        let computedData = data;
        computedData = computedData.filter(data => {
            return values.memberType === 'Valid' ? data.status === 'New' || data.status === "Renew" : values.memberType === 'Guest' ? data.status === "" : data
        });
        return computedData
    }, [values, data]);

    const isDelete = (item) => {
        const newData = data.filter(e => { return e.id !== item.id });
        setData(newData)
        console.log(newData);
    }

    const handleDelete = (item) => {
        confirmAlert({
            message: "Are you sure you want to Delete?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => isDelete(item)
                },
                {
                    label: 'Cancel',
                    onClick: () => null
                }
            ],
            overlayClassName: "react-confirm-alert-overlay react-confirm-alert-body"
        })
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value })
    };
    // console.log(values);

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a href=''>Previous</a>;
        } else if (type === 'next') {
            return <a href=''>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = filteredData.slice(indexOfFirstPage, indexOfLastPage);

    return (
        <div className='page_first_div '>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div'>
                <p className='page_topic inline-block'>All Members</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/members/" className='link block text-white text-sm'>
                        <i className="fa-solid fa-square-plus mr-1"></i>
                        Add
                    </Link>
                </div>
                <section className='page_section min-h-[23rem]'>

                    {/* showing success message when form updated */}
                    {alert && <AlertMessage />}

                    {/* selectors and search bars */}
                    <form className='flex flex-col justify-center px-4 xsm:px-8 lg:flex-row 2xl:justify-start items-center flex-wrap gap-4 py-4 '>
                        <div className='font-lato w-full lg:w-auto'>
                            <select className="selector w-full lg:w-80 bg-gray-100" name='memberType' value={values.memberType} onChange={handleChange}>
                                <option value="All">All Members</option>
                                <option value="Valid">Valid Member</option>
                                <option value="Guest">Guest Member</option>
                            </select>
                        </div>
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </form>

                    {/* show option and convert buttons */}
                    <div className='pt-2 flex flex-col gap-4 justify-center md:justify-between px-4 xsm:px-8 md:flex-row'>
                        <SelectList
                            setPostPerPage={setPostPerPage}
                            data={data}
                        />
                        <ConvertButtons
                            data={data}
                            ref={dataRef}
                        />
                    </div>

                    {/* members table data details */}
                    <MembersTable
                        data={currentPost}
                        sortData={data}
                        setData={setData}
                        onDelete={handleDelete}
                        searchTerm={searchTerm}
                        ref={dataRef}
                    />

                    {/* Pagination */}
                    <div className='px-4 xsm:px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={filteredData.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AllMembers;